<div id="indicator" [className]="indicator$ | async"></div>